import React, { useState } from 'react' ; 
import "./getToke.css" ; 
import { notEmpty } from '../../Validation';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getFBToken, getTokenAPI } from '../../RTK/Slice/UserSlice';
import { STATUS } from '../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const GetTokenPage = () => {

  // For Access Input 
  const [fbId , setFbId] = useState('') ; 
  const [password, setPassword] = useState("") ; 
  const [fa2 , setFa2]  =useState('') ; 



  // For Access Token Got From FB
  const {AcessToken , tokenStatus} = useSelector(getFBToken) ; 
  // For Disparch Action
  const dispatch = useDispatch() ; 

  // For Handle get token lite
  const getTokenLiteHandler = (e)=>{
    e.preventDefault() ; 
    if(notEmpty(fbId) && notEmpty(password) && notEmpty(fa2)){
      dispatch(getTokenAPI({fbId , password , fa2}))
    }else{
      toast.info("Please Complete Feilds")
    }
  }


  return (
    <section className='get-token-page'>
      <h2 className='gettoken-title'>Get Token </h2>
      <form onSubmit={getTokenLiteHandler}>
        <div className='input-row'>
          <label className='input-label' htmlFor='fb-id'>Facebook ID</label>
          <input value={fbId} onChange={(e)=>setFbId(e.target.value)} autoFocus id='fb-id' placeholder='Facebook ID' />
        </div>
        <div className='input-row'>
          <label className='input-label' htmlFor='fb-id'>Password</label>
          <input value={password} onChange={(e)=>setPassword(e.target.value)} autoFocus id='fb-id' placeholder='Enter password' />
        </div>
        <div className='input-row'>
          <label className='input-label' htmlFor='fb-id'>2FA</label>
          <input value={fa2} onChange={(e)=>setFa2(e.target.value)} autoFocus id='fb-id' placeholder='Enter 2FA' />
        </div>
        <button type='submit' className='getTknbtn'> {tokenStatus === STATUS.LOADDING ? <FontAwesomeIcon spin icon={faCircleNotch} />:"Get Token"}</button>
      </form>
        <p className='display-token'> {AcessToken}</p>
    </section>
  )
}

export default GetTokenPage
